// import { onMessage } from 'firebase/messaging';
// import { messaging } from './firebaseMessaging';

// export const listenForMessages = () => {
//   onMessage(messaging, (payload) => {
//     console.log('Foreground message received:', payload);

//     if (Notification.permission === 'granted') {
//      new Notification(payload.data.title, {
//   body: payload.data.body,
// });
//     }
//   });
// };
//heena
import { onMessage } from 'firebase/messaging';
import { messaging } from './firebaseMessaging';

export const listenForMessages = () => {
  onMessage(messaging, (payload) => {
    console.log('Foreground message received:', payload);

    const title = payload?.notification?.title;
    const body = payload?.notification?.body;

    if (Notification.permission === 'granted' && title) {
      new Notification(title, {
        body: body || '',
      });
    }
  });
};
